/**
 *
 *
 * @export devLogger
 * @param {String} - message the message to log
 * @param {*} - value you want to see
 * @param {String} - type oneOf 'log' || 'error'
 * @returns {Array}
 */
export const devLogger = (message = '', value = '', type = 'log') => {
  if (process.env.NODE_ENV === 'development') {
    /* eslint-disable no-console */
    if (type === 'log') console.log(`devLogger() - ${message}: `, value);
    if (type === 'error') console.error(`devLogger() - ${message}: `, value);
    /* eslint-enable no-console */
  }
};



// WEBPACK FOOTER //
// ./src/util/devLogger.js